import dayjs from 'dayjs';
import { parseDateTimeIgnoringTz } from 'features/common/datetimeUtils';

export const BIN_WIDTH_MINUTES_TO_MS = 60 * 1000;

export function ts_to_minutes(ts: string, targetDate?: string): number {
  const t = parseDateTimeIgnoringTz(ts);
  if (targetDate) {
    const diff = t.diff(dayjs(targetDate), 'minute');
    return diff;
  } else {
    const m = t.hour() * 60 + t.minute();
    return m;
  }
  // const offset = (60 * t.hour()) + t.minute();
}

export function min_string_to_minutes(ts: string): number {
  const t = dayjs(ts, 'HH:mm');
  const m = t.hour() * 60 + t.minute();
  return m;
}

export function minutes_to_slots(mins: number, binSize: number): number {
  return Math.floor((mins + 3 * 60) / binSize);
}

export function slots_to_minutes(slot: number, binSize: number): number {
  return slot * binSize - 3 * 60;
}

export function max_slots(binSize: number): number {
  return minutes_to_slots((24 + 3) * 60, binSize);
}

export function ts_to_slots(
  ts: string,
  binSize: number,
  targetDate: string,
): number {
  const mins = ts_to_minutes(ts, targetDate);
  return minutes_to_slots(mins, binSize);
}

export function binEndFromTs(ts: number, bin_size: number): number {
  return ts + bin_size * BIN_WIDTH_MINUTES_TO_MS;
}
